<h2 mat-dialog-title class="text-center">
    <span class="text-white">{{ isEditMode ? 'Editar Cliente' : 'Crear Nuevo Cliente' }}</span>
    <button matIconButton (click)="onCancel()" class="dialog-close top-0 right-0">
        <mat-icon>close</mat-icon>
    </button>
</h2>
<mat-dialog-content>
    <form [formGroup]="partnerForm" (ngSubmit)="onSubmit()">
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Nombre Visible</mat-label>
            <input matInput formControlName="displayName" placeholder="Ej: Nombre del Cliente" class="text-lg text-white bg-blue-primary">
        </mat-form-field>
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">NIT</mat-label>
            <input matInput formControlName="NIT" placeholder="Ej: 1234567-8" class="text-lg text-white bg-blue-primary">
            <mat-error *ngIf="NITControl?.invalid && (NITControl?.dirty || NITControl?.touched)">
                <span *ngIf="NITControl?.errors?.['required']">El NIT es requerido.</span>
            </mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Número de Cuenta</mat-label>
            <input matInput formControlName="accountNumber" placeholder="Ej: 1234567890" class="text-lg text-white bg-blue-primary">
            <mat-error *ngIf="accountNumberControl?.invalid && (accountNumberControl?.dirty || accountNumberControl?.touched)">
                <span *ngIf="accountNumberControl?.errors?.['required']">El número de cuenta es requerido.</span>
            </mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Correo Electrónico</mat-label>
            <input matInput formControlName="email" placeholder="Ej: cliente@example.com" class="text-lg text-white bg-blue-primary" cdkFocusInitial>
            <mat-error *ngIf="emailControl?.invalid && (emailControl?.dirty || emailControl?.touched)">
                <span *ngIf="emailControl?.errors?.['required']">El correo electrónico es requerido.</span>
                <span *ngIf="emailControl?.errors?.['email']">Ingrese un formato de correo válido.</span>
            </mat-error>
        </mat-form-field>
        <div>
            <mat-slide-toggle formControlName="paysISR" class="mb-4">
                Paga ISR
            </mat-slide-toggle>
        </div>
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Modo Facturación</mat-label>
            <mat-select formControlName="billingMode">
                <mat-option value="DAILY">Diario</mat-option>
                <mat-option value="WEEKLY">Semanal</mat-option>
            </mat-select>
            <mat-error *ngIf="billingModeControl?.invalid && (billingModeControl?.dirty || billingModeControl?.touched)">
                <span *ngIf="billingModeControl?.errors?.['required']">El modo de facturación es requerido.</span>
            </mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Agrupación de notificación</mat-label>
            <mat-select formControlName="notificationGroupingMode">
                <mat-option value="partner">Cliente</mat-option>
                <mat-option value="partner_entity">Entidad</mat-option>
                <mat-option value="partner_route">Ruta</mat-option>
                <mat-option value="partner_bus">Bus</mat-option>
            </mat-select>
            <mat-error *ngIf="notificationGroupingModeControl?.invalid && (notificationGroupingModeControl?.dirty || notificationGroupingModeControl?.touched)">
                <span *ngIf="notificationGroupingModeControl?.errors?.['required']">La agrupación de notificación es requerida.</span>
            </mat-error>
        </mat-form-field>
        <div>
            <mat-slide-toggle formControlName="disabled" class="mb-4">
                Deshabilitado
            </mat-slide-toggle>
        </div>
        <div *ngIf="!isEditMode">
            <mat-slide-toggle formControlName="sendEmail" class="mb-4">
                Enviar correo de bienvenida con accesos
            </mat-slide-toggle>
        </div>
        <div *ngIf="isEditMode && data?.disabled === false">
            <button matButton type="button" class="w-full mb-4" (click)="onSendWelcomeEmail()">
                Enviar correo de bienvenida
            </button>
        </div>
        <div>
            <button matButton type="submit" class="w-full">Guardar</button>
        </div>
    </form>
</mat-dialog-content>
